export default "__VITE_ASSET__DG20HkoK__"